import "./index.css";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import SystemBoundary from "../HeaderBox/SystemBoundary";

const SubHeaderBox = ({
  subTitle,
  scope,
  subDescription,
  isNormal,
  number,
  systemBoundaryProps,
  showSystemBoundary,
  icon,
  customBGColor,
  customTextColor,
  isCategory,
  handleShowCategory,
  showCategory,
}) => {
  const titleStyle = customTextColor ? { color: customTextColor } : undefined;
  const descStyle = customTextColor ? { color: customTextColor } : undefined;

  return (
    <div className="subheader-box lovable-subheader">
      <div className="lovable-subheader__icon-wrap">
        {icon ? (
          <img src={icon} alt="" width={28} height={28} />
        ) : (
          <SettingsOutlinedIcon className="lovable-subheader__default-icon" />
        )}
      </div>

      <div className="lovable-subheader__content">
        <div className="lovable-subheader__title-row">
          <h2 className="lovable-subheader__title" style={titleStyle}>
            {subTitle}
          </h2>
          {number && (
            <span className="lovable-subheader__flow-badge">{number}</span>
          )}
        </div>

        {scope && <p className="lovable-subheader__scope">{scope}</p>}

        {subDescription && (
          <p className="lovable-subheader__description" style={descStyle}>
            {subDescription}
          </p>
        )}

        {isCategory && (
          <div
            className="create-category-bg"
            style={{ maxWidth: "70%", marginTop: "12px" }}
          >
            <div className="create-category-left">
              <h5 style={{ fontSize: "14px" }}>Create Category</h5>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <h5 style={{ marginRight: "5px", fontSize: "14px" }}>Add</h5>
              <div
                className="create-category-switch"
                onClick={handleShowCategory}
                style={{
                  maxWidth: "fit-content",
                  display: "flex",
                  height: "100%",
                }}
              >
                <div
                  className={
                    showCategory ? "create-category-chosen-switch" : ""
                  }
                  style={{ width: "50px", height: "100%" }}
                />
                <div
                  className={
                    !showCategory ? "create-category-chosen-switch" : ""
                  }
                  style={{ width: "50px", height: "100%" }}
                />
              </div>
              <h5 style={{ marginLeft: "5px", fontSize: "14px" }}>Off</h5>
            </div>
          </div>
        )}

        {showSystemBoundary && <SystemBoundary {...systemBoundaryProps} />}
      </div>
    </div>
  );
};

export default SubHeaderBox;
